import Rails from '@rails/ujs';
import sweetAlert from 'sweetalert';

const SubmitToAction = {
  start() {
    $('button[data-submit-action]').on('click', this.buttonClick.bind(this));
  },

  buttonClick(e) {
    e.preventDefault();
    const $button = $(e.currentTarget);
    const action = $button.data('submit-action');
    const options = $button.data('submit-options') || {};
    const formId = options.form;
    const $formFromId = $(formId);
    const $form = formId ? $formFromId : $button.closest('form');
    if (options.save_first) {
      // Open the new tab synchronously on the user gesture so it isn't popup-blocked,
      // then navigate it after the save completes.
      const newTab = window.open('about:blank', '_blank');
      if (!newTab) {
        sweetAlert({
          title: 'Popup blocked',
          text: 'Please allow popups for this site to preview the email.',
          icon: 'warning'
        });
        return;
      }
      if (options.confirm) {
        this.askConfirmation(options.confirm)
          .then(() => this.saveAndOpen($form, action, newTab))
          .catch(() => newTab.close());
      } else {
        this.saveAndOpen($form, action, newTab);
      }
      return;
    }
    if (options.confirm) {
      this.askConfirmation(options.confirm).then(() => this.submitForm($form, action, options));
    } else {
      this.submitForm($form, action, options);
    }
  },

  submitForm($form, action, options) {
    const oldAction = $form.attr('action');
    $form.attr('action', action);
    if (options.blank) {
      $form.attr('target', '_blank');
    }
    if (options.method) {
      $form
        .attr('method', 'get')
        .find('[name=_method]')
        .val(options.method);
    }
    $form.submit();
    if (options.blank) {
      setTimeout(() => {
        $form
          .attr('action', oldAction)
          .attr('target', '')
          .attr('method', 'post')
          .find('[name=_method]')
          .val('patch');
      }, 0);
    }
  },

  saveAndOpen($form, openUrl, newTab) {
    // Froala keeps its working copy in an iframe; mirror the latest HTML back to
    // the underlying textarea so FormData captures the current editor state.
    $form.find('[data-component=richtext-field]').each(function syncFroala() {
      const $textarea = $(this);
      const editor = $textarea.data('froala.editor');
      if (editor && editor.html && typeof editor.html.get === 'function') {
        $textarea.val(editor.html.get());
      }
    });

    fetch($form.attr('action'), {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': Rails.csrfToken(),
        Accept: 'application/json'
      },
      body: new FormData($form.get(0))
    })
      .then((response) => {
        if (response.ok) {
          newTab.location = openUrl;
        } else {
          newTab.close();
          sweetAlert({
            title: 'Error',
            text: 'Could not save before preview. Please try again.',
            icon: 'error'
          });
        }
      })
      .catch((error) => {
        newTab.close();
        Rollbar.error(`Error saving before preview at ${$form.attr('action')}`, error);
        sweetAlert({
          title: 'Error',
          text: 'Could not save before preview. Please try again.',
          icon: 'error'
        });
      });
  },

  askConfirmation(message) {
    return sweetAlert({
      title: 'Warning!',
      text: message,
      icon: 'warning',
      buttons: ['Cancel', 'Continue']
    }).then(result => (result ? Promise.resolve() : Promise.reject()));
  }
};

export default SubmitToAction;
